import {fetchWrapper} from './fetch';
import {endpoints} from "../utils2";


/* Exposed functions */
export const backend = {
    signup,
    verifyEmail,
    resendEmail,
    forgotPassword,
    resetPassword,
    login,
    refreshToken,
    logout,
    editUser,
    deleteUser,
}

/**
 * Signup by sending a valid JSON object containing at least email, password, and accept.
 *
 * @param payload E.g., {"firstname":"Luca", "username":"luca.pascarella@gmail.com", "password":"Password1234", "accept": true}
 * @returns {Promise<Response>}
 */
function signup(payload) {
    return fetchWrapper.post(endpoints.user.signup(), payload)
}

/**
 * Verify email API by passing a valid JSON object containing the token received by email.
 *
 * @param payload E.g., {"token":"JWT_valid_token"}
 * @returns {Promise<Response>}
 */
function verifyEmail(payload) {
    return fetchWrapper.post(endpoints.user.verifyEmail(), payload)
}

/**
 * Request a new email with a verification link. A valid JSON object containing the email to which send the reset link.
 *
 * @param payload E.g., {"email": "luca.pascarella@gmail.com"}
 * @returns {Promise<Response>}
 */
function resendEmail(payload) {
    return fetchWrapper.post(endpoints.user.resendEmail(), payload)
}

/**
 * Request a password reset link. A valid JSON object containing the email to which send the reset link.
 *
 * @param payload E.g., {"email": "luca.pascarella@gmail.com"}
 * @returns {Promise<Response>}
 */
function forgotPassword(payload) {
    return fetchWrapper.post(endpoints.user.forgotPassword(), payload)
}

/**
 * Change the current password.
 * The request is a valid JSON object containing the token received by email and the new password
 *
 * @param payload E.g., {"token":"TOKEN RECEIVED BY EMAIL", "password":"new5tr0ng5ecret"}
 * @returns {Promise<Response>}
 */
function resetPassword(payload) {
    return fetchWrapper.post(endpoints.user.resetPassword(), payload)
}

/**
 * Authenticate a user session.
 *
 * @param payload E.g., {"username": "luca.pascarella@gmail.com", "password":"Password1234"}
 * @returns {Promise<{success:bool, data:{token:{jwt:string, refresh_at:string}, user:{username:string, first_name:string, last_name:string, location:string}}}>}
 */
function login(payload) {
    // Pass through Remote server. Submit POST
    return fetchWrapper.post(endpoints.user.login(), payload)
}

/**
 * Refresh JWT (session token)
 *
 * @returns {Promise<{success:bool, data:{token:str, refresh_at:str}}>}
 */
function refreshToken(jwt) {
    // Send an empty GET request and wait for a fresh JWT
    return fetchWrapper.get(endpoints.user.refreshToken(), jwt)
}

/**
 * Terminate a user session and delete data.
 */
function logout() {
    // Actually doing nothing
    return Promise.resolve()
}


/**
 * Edit user. Admin management
 *
 * @param jwt
 * @param requestUserId
 * @param targetUserId
 * @param payload
 * @returns {Promise<{success:bool, data:{username:string, first_name:string, last_name:string, location:string}}>}
 */
function editUser(jwt, requestUserId, targetUserId, payload) {
    return fetchWrapper.put(endpoints.user.edit(targetUserId), payload, jwt);
}

/**
 * Delete user. Admin management
 *
 * @param jwt
 * @param requestUserId
 * @param targetUserId
 * @returns {Promise<Response>}
 */
function deleteUser(jwt, requestUserId, targetUserId) {
    return fetchWrapper.delete(endpoints.user.delete(targetUserId), jwt);
}
